import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { InfoBoxStatus } from './info-box.enum';

@Component({
  selector: 'app-info-form-box',
  templateUrl: './info-form-box.component.html',
  styleUrls: ['./info-form-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIcon],
})
export class InfoFormBoxComponent {
  readonly status = input<InfoBoxStatus>(InfoBoxStatus.INFO);
  readonly showIcon = input(true);
}
